"use strict";

angular.module("core")
.service("StateExtensionService", function($state, $stateParams) {
    this.updateUrlParams = function(params) {
        return $state.transitionTo($state.$current.name, angular.extend($stateParams, params), {
            location: "replace",
            inherit: true,
            relative: $state.$current,
            notify: false
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/state-extension/state-extension.service.js
// module id = 427
// module chunks = 0